module.exports = __webpack_public_path__ + "img/care-offer-1.1f0a6f03.jpg";